import { render, staticRenderFns } from "./NavBarAudit.vue?vue&type=template&id=478b40a8"
import script from "./NavBarAudit.vue?vue&type=script&lang=js"
export * from "./NavBarAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports